import React, { Component,Fragment } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import JSONViewIcon from '@mui/icons-material/MoreHorizRounded';
import JsonView from '../view/JsonView';
import {extendedstyles} from '../../app/appstyles';

const extrastyles = (theme:Theme):any => ({
  preview: {
    height: 95,
    padding: '5px 15px 0 15px'
  },
});

const styles = extendedstyles(extrastyles);

class Dataset extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      position:props.location,
      map: null,
      view:false,
      zoom: 13,
      info: props.info
    };
  }

  mouseDown = (event:any) => {
    event.preventDefault();
  }

  openView = (event:any) => {
    this.setState({view:true});
  }

  closeView = (event:any) => {
    this.setState({view:false});
  }

  render() {
    const {label, rec, style, value, classes} = this.props;
    const {view} = this.state;

    return (
      <Fragment>
      <IconButton aria-label="View" style={style} onClick={this.openView} onMouseDown={this.mouseDown}>
        <JSONViewIcon />
      </IconButton>
      <JsonView open={view} value={value} label={label} rec={rec} onClose={this.closeView} />
      </Fragment>
    );
  }
}

Dataset.propTypes = {
  data: PropTypes.array
};

export default withStyles(styles, { withTheme: true })(Dataset);
